import React from "react";
import { ECLNumber } from "../../../../index";
import "./ECLInput.css";

export default function ECLDuration(props) {
   return (
      <>
         <label>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <div className="ecl-input-container-combo">
            <ECLNumber
               id={props.id}
               min={props.min}
               max={props.max}
               required={props.required}
               style={{ width: "calc(100% - 80px)" }} //hate inlining style, but needs to be based on length of selections below
            />
            <select
               className="ecl-input-selection"
               id={"select-" + props.id}
               style={{ width: "80px" }}
            >
               <option value="hours">Hours</option>
               <option value="minutes">Minutes</option>
               <option value="seconds">Seconds</option>
               <option value="milliseconds">Milliseconds</option>
            </select>
         </div>
      </>
   );
}
